import React, { useContext, useEffect } from "react";
import { PackagesContext } from "../../context/PackageContext";
import { PurchasesContext } from "../../context/PurchasesContext";
import MonterreyPackagesCarousel from "../paquetes/MonterreyPackagesCarousel";
import useTrialClass from "../../hooks/useTrialClass";
import { getValue } from "../../utils";

const MonterreyLandingPackages = ({ branch_id }) => {
  const { paquetes, getPaquetes } = useContext(PackagesContext);
  const { getPurchases } = useContext(PurchasesContext);
  const { trial_class_package } = useTrialClass();

  useEffect(() => {
    getPaquetes();
    getPurchases();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPackages = () => {
    if (Array.isArray(paquetes)) {
      let paquetesRender = paquetes
        ?.filter(
          ({ class_amount, is_special_event }) =>
            class_amount > 0 ||
            getValue({ is_special_event }, "is_special_event", "boolean"),
        )
        .sort((a, b) => {
          const aSpecial = getValue(a, "is_special_event", "boolean");
          const bSpecial = getValue(b, "is_special_event", "boolean");
          if (aSpecial && !bSpecial) return -1;
          if (!aSpecial && bSpecial) return 1;
          return a.class_amount < b.class_amount ? -1 : 1;
        });
      if (
        trial_class_package &&
        !paquetesRender?.some(
          (p) => p.class_package_id === trial_class_package.class_package_id
        )
      ) {
        paquetesRender?.unshift(trial_class_package);
      }
      return paquetesRender;
    }
    return [];
  };

  return (
    <div id="scrollspyMtyPackages" className="container-fluid py-5 bg-white">
      <h2 className="h1 text-center text-black packages-carousel__title">
        Elige tu membresía
      </h2>
      <p className="text-black text-center packages-carousel__subtitle">
        Todos nuestros paquetes presenciales incluyen TBM ONLINE de forma
        ilimitada.
      </p>

      <div className="container-fluid packages-carousel__container">
        <MonterreyPackagesCarousel packages={getPackages()} branch_id={branch_id} />
      </div>
    </div>
  );
};

export default MonterreyLandingPackages;
